import React from 'react';

import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import SubmitButton from '../../components/SubmitButton/SubmitButton';
import Header from '../../components/Header/Header';
import Logo from '../../assets/svgs/Logo';
import privacyIllustration from '../../assets/images/healthscan-register-illustration.svg';
import translate from '../../libs/i18n';

import { PrivacyPolicyStyle } from './PrivacyPolicyStyle';

const PrivacyPolicy = ({  }) => { 
  const language = useSelector((state) => state.settings.language);

  return (
    <PrivacyPolicyStyle>
      <section className="privacy-policy-section">
        <div className="privacy-policy-content">
          <div className="privacy-policy-head">
            <h1 className="privacy-policy-head-title">{translate('privacyPolicyTitle', language)}</h1>
            <p className="privacy-policy-head-description">
              {translate('privacyPolicyDescription', language)}
            </p>
          </div>

          <div className="privacy-policy-container">
            <div className="privacy-policy-container-content">
              <div className="terms-of-service-container-description" style={{ whiteSpace: 'pre-line' }}>
                {translate('privacyPolicy1', language)}
                <a rel="noreferrer" href="https://www.planalto.gov.br/ccivil_03/constituicao/constituicao.htm" target="_blank" className="forgot-password">
                  {translate('brazilianConstitution', language)}
                </a>
                {translate('privacyPolicy2', language)}
                <ul>
                  <li>
                    <a href="https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam?redirectlocale=en-US&redirectslug=Enabling+and+disabling+cookies" rel="noreferrer" target="_blank" className="forgot-password" >
                      {translate('firefoxCookieConfig', language)}
                    </a>
                  </li>
                  <li>
                    <a href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies" rel="noreferrer" target="_blank" className="forgot-password">
                      {translate('explorerCookieConfig', language)}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.google.com/support/chrome/bin/answer.py?answer=95647" rel="noreferrer" target="_blank" className="forgot-password">
                      {translate('chromeCookieConfig', language)}
                    </a>
                  </li>
                  <li>
                    <a href="https://support.apple.com/kb/PH17191?viewlocale=en_US&locale=pt_BR" rel="noreferrer" target="_blank" className="forgot-password">
                      {translate('safariOSXCookieConfig', language)}
                    </a>
                  </li>
                  <li>
                    <a href="https://support.apple.com/pt-br/HT201265" rel="noreferrer" target="_blank" className="forgot-password">
                      {translate('safariOSCookieConfig', language)}
                    </a>
                  </li>
                  <li>
                    <a href="https://support.google.com/chrome/answer/95647?hl=en&co=GENIE.Platform=Android" rel="noreferrer" target="_blank" className="forgot-password">
                      {translate('androidCookieConfig', language)}
                    </a>
                  </li>
                </ul>
                {translate('privacyPolicy3', language)}
                <a href="https://tools.google.com/dlpage/gaoptout?hl=pt-BR" rel="noreferrer" target="_blank" className="forgot-password">
                  {translate('clickHere', language)}
                </a>
                {translate('privacyPolicy4', language)}
              </div>
            </div>
          </div>
         </div>
      </section>
    </PrivacyPolicyStyle>
  );
};

export default PrivacyPolicy;
